import { GrufBus } from "../GrufBus";
import { DJFilter } from "../fx/DJFilter";
import { Analyser, dbToGain, Gain, Limiter, ToneAudioNode } from "tone";

const SPECTRUM_SIZE = 64;
export class MasterChannel extends ToneAudioNode {
    static parametersDescription = {
        ...GrufBus.parametersDescription,
        djfValue: {type: 'float', min: 0, max: 1, initial: 0.5},
        djfQ: {type: 'float', min: 0, max: 10, initial: 0},
    }

    constructor() {
        super();
        this.bus = new GrufBus();
        this.pregain = new Gain(); 
        this.djf = new DJFilter();
        this.pregain.chain(this.djf, this.bus);

        this.limiter = new Limiter(-1);
        this.preLimiterGain = new Gain(dbToGain(6));
        this.fft = new Analyser('fft', SPECTRUM_SIZE);
        this.bus.chain(this.preLimiterGain, this.limiter);
        this.bus.connect(this.fft);
        this.input = this.pregain;
        this.output = this.limiter;
    }

    set gain(value) {
        this.bus.gain = value;
    }

    set pan(value) {
        this.bus.pan = value;
    }

    set djfValue(value) {
        this.djf.set({value});
    }

    set djfQ(value) {
        this.djf.set({Q: value});
    }

    get spectrumSize() {
        return SPECTRUM_SIZE;
    }

    get spectrumData() {
        return this.fft.getValue();
    }

    dispose() {
        this.bus.dispose();
        this.limiter.dispose();
        this.preLimiterGain.dispose();
        this.fft.dispose();
    }

    getCurrentLevels() {
        return this.bus.getCurrentLevels();
    }
}